/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Storytelling (C) Copyright IBM Corp. 2018, 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'storytelling/nls/StringResources',
	'baglass/core-client/js/core-client/utils/UniqueId'
], function(stringResources, UniqueId){
	return {
		get: function() {
			var titleId = UniqueId.get('title_');
			var text1Id = UniqueId.get('text1_');
			var vis1Id = UniqueId.get('vis1_');

			return {
				layout: {
					type: 'container',
					templateName: 'Template1',
					items: [{
						type: 'genericPage',
						layoutPositioning: 'relative',
						css: 'templateBox aspectRatio_default',
						items: [{
							type: 'templateIndicator',
							style: {
								'top': '0%',
								'left': '0%',
								'right': '0%',
								'bottom': '0%'
							}
						},{
							id: titleId,
							type: 'widget',
							style: {
								width: '98.00%',
								height: '20.00%',
								top: '1.82%',
								left: '1.00%'
							}
						}, {
							id: text1Id,
							type: 'widget',
							style: {
								width: '30.00%',
								height: '74.54%',
								top: '23.64%',
								left: '1.00%'
							}
						}, {
							id: vis1Id,
							type: 'widget',
							style: {
								width: '67.00%',
								height: '74.54%',
								top: '23.64%',
								left: '32.00%'
							}
						}]
					}]
				},
				widgets: {
					[titleId]: {
						id: titleId,
						type: 'text',
						isResponsive: true,
						placeholder: {
							text: stringResources.get('titleWidgetPlaceholderText')
						},
						content: '<div class="staticContent"><span class="textFitted responsiveColor responsiveFontSize responsiveFontFamily"><p style="text-align: center;"><br></p></span></div>',
						name: stringResources.get('titleWidgetPlaceholderText'),
						defaults: {
							justifyCenter: true
						}
					},
					[text1Id]: {
						id: text1Id,
						type: 'text',
						placeholder: {
							iconType: 'list'
						},
						content: '<div class="staticContent"><span class="textFitted responsiveColor responsiveFontSize responsiveFontFamily"><ul><li><br></li></ul></span></div>',
						name: '',
						defaults: {
							fontSize: '20'
						}
					},
					[vis1Id]: {
						id: vis1Id,
						type: 'multipurpose',
						placeholder: {
							iconType: 'vis'
						}
					}
				}
			};
		}
	};
});
